// TODO: Add unit tests

// A default object to ensure the required props exist
const defaultBps = {
    minWidth: 0,
    maxWidth: 0
}

/**
* Creates a media query (matchmedia) object to query / add event listeners to
* @param {Object} breakpoints - {minWidth : Number, maxWidth: Number}
* @returns {Object} - Window matchmedia object
*/
const create = (breakpoints = defaultBps) => {
    const { minWidth, maxWidth } = Object.assign({}, defaultBps, breakpoints);

    if (!maxWidth && !minWidth) return window.matchMedia('screen')

    let _media = [
        maxWidth ? `(max-width: ${maxWidth}px)` : '',
        minWidth ? `(min-width: ${minWidth}px)` : ''
    ].join(' and ');

    _media = _media.replace(/(?:\sand\s)$/, '')

    return window.matchMedia(_media)
}

const MediaQuery = { create }
export default MediaQuery



// WEBPACK FOOTER //
// ./js/utils/MediaQuery.js